import { render, staticRenderFns } from "./choose-change.component.vue?vue&type=template&id=1b4fa2e0"
import script from "./choose-change.component.ts?vue&type=script&lang=ts&external"
export * from "./choose-change.component.ts?vue&type=script&lang=ts&external"
import style0 from "./choose-change.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports